import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';

export const selectSpecialtyTypes = createSelector(
  selectJsonQuery,
  jsonQuery => getTermsValue('specialty_types')(jsonQuery) as number[] | null,
);
